import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { LOCATION_CONTROLER_URL } from "api/Service";

export const useDeleteLocation = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (id) => {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.delete(`${tenantVal}${LOCATION_CONTROLER_URL}/${id}`);
    },
    onSuccess: async () => {
      toast.success("Location removed successfully");
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["locationsAll"] }),
        queryClient.invalidateQueries({ queryKey: ["locationsActive"] }),
      ]);
    },
    onError: (error) => {
      // 409 CONFLICT ("Cannot remove the only location") carries a specific,
      // user-facing message from ApiExceptionHandler — surface it verbatim
      // rather than a generic failure toast.
      const message =
        error?.response?.data?.message || "Failed to remove location";
      toast.error(message);
    },
  });
};
